import React from 'react';
import { useTheme } from '../App';

function Messages({ messages }) {
  const { theme } = useTheme();
  
  const renderMessage = (msg, index) => {
    switch (msg.type) {
      case 'error':
        return (
          <div key={index} style={{ marginBottom: '10px', fontFamily: 'inherit' }}>
            <div style={{ color: '#ff6b6b' }}>
              {msg.command} : The term '{msg.command}' is not recognized as the name of a cmdlet, function, script file, or operable program.
            </div>
            <div style={{ color: '#ff6b6b' }}>
              Check the spelling of the name, or if a path was included, verify that the path is correct and try again.
            </div>
            <div style={{ color: '#ff6b6b', marginTop: '5px' }}>
              At line:1 char:1
            </div>
            <div style={{ color: '#ff6b6b' }}>
              + {msg.command}
            </div>
            <div style={{ color: '#ff6b6b' }}>
              + {Array(msg.command.length + 1).join('~')}
            </div>
            <div style={{ color: '#ff6b6b' }}>
              + CategoryInfo          : ObjectNotFound: ({msg.command}:String) [], CommandNotFoundException
            </div>
            <div style={{ color: '#ff6b6b' }}>
              + FullyQualifiedErrorId : CommandNotFoundException
            </div>
            {msg.suggestion && (
              <div style={{ color: theme.colors.accentCyan, marginTop: '10px' }}>
                Suggestion: Did you mean '{msg.suggestion}'? Type 'help' for available commands.
              </div>
            )}
          </div>
        );
      
      case 'output':
        return (
          <div key={index} style={{ marginBottom: '10px', whiteSpace: 'pre-wrap', color: theme.colors.foreground }}>
            {msg.content}
          </div>
        );
      
      case 'help':
        return (
          <div key={index} style={{ marginBottom: '10px' }}>
            <div style={{ color: theme.colors.accentGreen, marginBottom: '10px' }}>
              READDIT TERMINAL - PowerShell Reddit Reader v1.0
            </div>
            <div style={{ marginBottom: '5px' }}>
              <span style={{ color: theme.colors.accentCyan, display: 'inline-block', width: '200px' }}>COMMAND</span>
              <span style={{ color: theme.colors.foreground }}>DESCRIPTION</span>
            </div>
            <div style={{ borderBottom: `1px solid ${theme.colors.accentCyan}`, marginBottom: '10px' }}></div>
            {msg.commands.map((cmd, i) => (
              <div key={i} style={{ marginBottom: '3px' }}>
                <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '200px' }}>{cmd.command}</span>
                <span style={{ color: theme.colors.foreground }}>{cmd.description}</span>
              </div>
            ))}
            <div style={{ marginTop: '15px', color: theme.colors.accentOrange }}>
              KEYBOARD SHORTCUTS:
            </div>
            <div style={{ marginTop: '5px' }}>
              <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '100px' }}>j/k</span>
              <span style={{ color: theme.colors.foreground }}>Navigate posts</span>
            </div>
            <div>
              <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '100px' }}>Enter/o</span>
              <span style={{ color: theme.colors.foreground }}>Open selected post in details panel</span>
            </div>
            <div>
              <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '100px' }}>Escape</span>
              <span style={{ color: theme.colors.foreground }}>Close details panel</span>
            </div>
            <div>
              <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '100px' }}>/</span>
              <span style={{ color: theme.colors.foreground }}>Focus command line</span>
            </div>
            <div>
              <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '100px' }}>Tab</span>
              <span style={{ color: theme.colors.foreground }}>Auto-complete commands</span>
            </div>
          </div>
        );
      
      case 'list':
        return (
          <div key={index} style={{ marginBottom: '10px', fontFamily: 'inherit', fontSize: '13px' }}>
            <div style={{ marginBottom: '5px' }}>
              <span style={{ color: theme.colors.accentCyan, display: 'inline-block', width: '50px' }}>INDEX</span>
              <span style={{ color: theme.colors.accentCyan, display: 'inline-block', width: '100px' }}>SUBREDDIT</span>
              <span style={{ color: theme.colors.accentCyan, display: 'inline-block', width: '60px' }}>SCORE</span>
              <span style={{ color: theme.colors.accentCyan }}>TITLE</span>
            </div>
            <div style={{ borderBottom: `1px solid ${theme.colors.accentCyan}`, marginBottom: '5px' }}></div>
            {msg.posts.map((post, i) => (
              <div key={i} style={{ marginBottom: '2px' }}>
                <span style={{ color: theme.colors.foreground, display: 'inline-block', width: '50px' }}>
                  {String(i + 1).padStart(3, ' ')}
                </span>
                <span style={{ color: theme.colors.accentOrange, display: 'inline-block', width: '100px' }}>
                  r/{post.data.subreddit.substring(0, 12)}
                </span>
                <span style={{ color: theme.colors.accentGreen, display: 'inline-block', width: '60px' }}>
                  {String(post.data.score).padStart(5, ' ')}
                </span>
                <span style={{ color: theme.colors.foreground }}>
                  {post.data.title.substring(0, 80)}{post.data.title.length > 80 ? '...' : ''}
                </span>
              </div>
            ))}
          </div>
        );

      case 'ascii':
        // Render ASCII art with monospace font. We use a <pre> tag to preserve spacing.
        return (
          <pre
            key={index}
            style={{
              color: theme.colors.accentGreen,
              marginBottom: '10px',
              whiteSpace: 'pre-wrap',
              fontFamily: 'CaskaydiaCove Nerd Font, monospace',
              fontSize: '14px',
              lineHeight: '1.2'
            }}
          >
            {msg.art}
          </pre>
        );
      
      default:
        return null;
    }
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      {messages.map((msg, index) => renderMessage(msg, index))}
    </div>
  );
}

export default Messages;